module.exports = __webpack_public_path__ + "img/brain.bd5344a8.png";